import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AboutSection from '../About/AboutSection'
import ServicesSection from '../Services/ServicesSection'
import Slider from '../Slider/Slider'
import FAQ from '../FAQ/FAQ'
import ConsultativeApproachSection from '../ConsultativeApproach/ConsultativeApproachSection'
import FeaturedProducts from '../Products/FeaturedProducts'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import BrochureSection from '../Brochure/BrochureSection'
import BlogSection from '../Blog/BlogSection'
import ContactSection from '../Cooperation/sections/ContactSection'
import Pricing from '../Pricing/Pricing'
import RegistrationSection from '../Registration/RegistrationSection'

function LandingPage () {
  const location = useLocation()

  useEffect(() => {
    // Obsługa hash fragmentów (np. #faq)
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1))
      if (element != null) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location.hash])

  return (
    <>
      <Header />
      <Slider />
      <AboutSection />
      <ServicesSection />
      <ConsultativeApproachSection />
      <FeaturedProducts />
      <BlogSection />
      <BrochureSection />
      <Pricing showHeader={false} showComparisonTable={false} />
      <FAQ />
      <RegistrationSection />
      <Footer />
    </>
  )
}

export default LandingPage
